import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsDownLeftChevron: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M0 6.364L6.364 0v9.636H16L9.636 16H0z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsDownLeftChevron
